import { reactNode } from '@shared/node-v1.0.0'

import v100 from '@nodes/loading-overlay-v1.0.0'

export default reactNode(
	'LoadingOverlay',
	{
		'v1.0.0': v100,
	},
	{ allowChildren: true, docs: '' }
)
